import { render, staticRenderFns } from "./Info_Gallery.vue?vue&type=template&id=bb110b28&scoped=true&"
import script from "./Info_Gallery.vue?vue&type=script&lang=js&"
export * from "./Info_Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Info_Gallery.vue?vue&type=style&index=0&id=bb110b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb110b28",
  null
  
)

export default component.exports